/**
 * Generated by orval v8.20.0 🍺
 * Do not edit manually.
 * Phaza Drive
 * In the documentation API requests will be sent from currently logged in user so you do not need to provide a bearer token manually. <br><br> When calling API from outside the documentation, you will need to provide an access token for all requests in authorization header: `Authorization: Bearer <Token>` <br> You can create a new access token in your account settings page.
 * OpenAPI spec version: 1.0.0
 */
import type {CreateCustomPageBody} from './schemas/create-custom-page-body';

import type {CreateCustomPage200} from './schemas/create-custom-page200';

import type {ListCustomPages200} from './schemas/list-custom-pages200';

import type {RetrieveCustomPage200} from './schemas/retrieve-custom-page200';

import type {UpdateCustomPageBody} from './schemas/update-custom-page-body';

import type {UpdateCustomPage200} from './schemas/update-custom-page200';

import {orvalApiFetch} from '../../../common/foundation/resources/client/http/query-client';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary List all custom pages
 */
export const listCustomPages = (
  options?: SecondParameter<typeof orvalApiFetch<ListCustomPages200>>,
) => {
  return orvalApiFetch<ListCustomPages200>(
    {url: `/custom-pages`, method: 'GET'},
    options,
  );
};
/**
 * @summary Create a custom page
 */
export const createCustomPage = (
  createCustomPageBody: CreateCustomPageBody,
  options?: SecondParameter<typeof orvalApiFetch<CreateCustomPage200>>,
) => {
  return orvalApiFetch<CreateCustomPage200>(
    {
      url: `/custom-pages`,
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      data: createCustomPageBody,
    },
    options,
  );
};
/**
 * @summary Retrieve a custom page
 */
export const retrieveCustomPage = (
  id: string | number,
  options?: SecondParameter<typeof orvalApiFetch<RetrieveCustomPage200>>,
) => {
  return orvalApiFetch<RetrieveCustomPage200>(
    {url: `/custom-pages/${id}`, method: 'GET'},
    options,
  );
};
/**
 * @summary Update a custom page
 */
export const updateCustomPage = (
  id: number,
  updateCustomPageBody?: UpdateCustomPageBody,
  options?: SecondParameter<typeof orvalApiFetch<UpdateCustomPage200>>,
) => {
  return orvalApiFetch<UpdateCustomPage200>(
    {
      url: `/custom-pages/${id}`,
      method: 'PUT',
      headers: {'Content-Type': 'application/json'},
      data: updateCustomPageBody,
    },
    options,
  );
};
/**
 * @summary Delete a custom page
 */
export const deleteCustomPage = (
  id: number,
  options?: SecondParameter<typeof orvalApiFetch<void>>,
) => {
  return orvalApiFetch<void>(
    {url: `/custom-pages/${id}`, method: 'DELETE'},
    options,
  );
};
export type ListCustomPagesResult = NonNullable<
  Awaited<ReturnType<typeof listCustomPages>>
>;
export type CreateCustomPageResult = NonNullable<
  Awaited<ReturnType<typeof createCustomPage>>
>;
export type RetrieveCustomPageResult = NonNullable<
  Awaited<ReturnType<typeof retrieveCustomPage>>
>;
export type UpdateCustomPageResult = NonNullable<
  Awaited<ReturnType<typeof updateCustomPage>>
>;
export type DeleteCustomPageResult = NonNullable<
  Awaited<ReturnType<typeof deleteCustomPage>>
>;
